import { objectSpread2 as _objectSpread2 } from './_virtual/_rollupPluginBabelHelpers.mjs';
import React, { useContext } from 'react';
import { ThemeContext } from 'styled-components';
import { SizeWrapper, TouchWrapper } from './styles/styledComponents.mjs';
import { jsx } from 'react/jsx-runtime';

var Svg18UpvoteC = /*#__PURE__*/React.memo(function (props) {
  useContext(ThemeContext);
  props.iconColor;
  var component = /*#__PURE__*/jsx("svg", _objectSpread2(_objectSpread2({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 18"
  }, props), {}, {
    children: /*#__PURE__*/jsx("path", {
      fill: props.iconColor ? props.iconColor : "#010505",
      fillRule: "evenodd",
      d: "M13.45 6.962a1.48 1.48 0 0 0-1.21-.63h-1.59l.5-1.33c.141-.392.12-.824-.06-1.2a1.4 1.4 0 0 0-.82-.73 1.44 1.44 0 0 0-1.6.5l-2.1 2.76h-2a.57.57 0 0 0-.57.58v4.51a.57.57 0 0 0 .57.58h7.31c.25 0 .473-.156.56-.39l1.2-3.31c.16-.45.09-.951-.19-1.34m-7.13 4H5.04v-3.63h1.28zm6.38-3-1.08 3h-4.3v-4l2.14-2.78a.44.44 0 0 1 .5-.16.36.36 0 0 1 .23.22.53.53 0 0 1 0 .41l-.7 1.94-.09.29.34.45h2.5a.482.482 0 0 1 .46.64z"
    })
  }));
  if (props.size) {
    component = /*#__PURE__*/React.createElement(SizeWrapper, {
      size: props.size
    }, component);
  }
  if (props.touch) {
    component = /*#__PURE__*/React.createElement(TouchWrapper, {
      size: props.size,
      touch: props.touch
    }, component);
  }
  return component;
});
var Svg18UpvoteC$1 = Svg18UpvoteC;

export { Svg18UpvoteC$1 as default };
